import React from 'react';

const Loading = () => (
  <p style={{width: '100%', textAlign: 'center'}}>Loading...</p>
)

export default Loading;
